//ALEX colors

export const ColorPalette = {
  blue: "#051A32",
  red: "#B60023",
  orange: "#EA880D",
  green: "#1C9A51",
};
